import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styles from "./sunset.module.scss";
import { Button } from "../ui/button.component";
import Link from "next/link";
import { selectUserState } from "app/store/slices/user";
import { useAppSelector } from "app/store/store";
import { useTranslate } from "app/hooks/lang";
import { useInterval } from "react-use";
import { differenceInMinutes } from "date-fns";

interface SunsetProps {}

export const Sunset: React.FC<SunsetProps> = ({}) => {
  const t = useTranslate();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { session } = useAppSelector(selectUserState);
  const [closeDate, setCloseDate] = useState<number | null>(null);
  const isStingray = useMemo(() => {
    return process.env.NEXT_PUBLIC_STINGRAY === "true";
  }, []);

  const isPremium = useMemo(
    () => session?.user && session?.user.premium,
    [session],
  );

  const checkTime = () => {
    if (
      !closeDate ||
      (closeDate && differenceInMinutes(Date.now(), closeDate) >= 60 * 12)
    ) {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    checkTime();
  }, []);

  useInterval(() => {
    checkTime();
  }, 60 * 1000);

  const close = useCallback(() => {
    const time = Date.now();
    setCloseDate(time);
    console.log("time", time);
    setIsOpen(false);
  }, []);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (wrapperRef.current && wrapperRef.current === event.target) {
        close();
      }
    },
    [close],
  );

  const buttonText = useMemo(() => {
    let result = isPremium ? t("sunset_cta_premium") : t("sunset_cta");
    if (isStingray) {
      result = result.replaceAll("TuneIn", "Stingray");
    }
    return result;
  }, [isPremium, isStingray, t]);

  return isOpen ? (
    <div
      className={styles.sunset_wrapper}
      ref={wrapperRef}
      onClick={(e) => handleClickOutside(e.nativeEvent)}
    >
      {isStingray ? (
        <div
          className={styles.stingray_main}
          data-navigate-item={true}
          tabIndex={0}
        >
          <div className={styles.stingray_inner}>
            <div className={styles.stingray_top}></div>
            <div className={styles.stingray_text}>
              <h1>{t("sunset_title")}</h1>

              {/* <p>&nbsp;</p> */}
              <p
                dangerouslySetInnerHTML={{
                  __html: t("sunset_desc", {
                    var1: "<br />",
                  }),
                }}
              />
              {/* <p>&nbsp;</p> */}
            </div>
            <div className={styles.stingray_button} onClick={() => close()}>
              {t("common_action_close")}
            </div>
          </div>
        </div>
      ) : (
        <div
          className={styles.sunset_main}
          data-navigate-item={true}
          tabIndex={0}
          ref={mainRef}
        >
          <div className={styles.sunset_top}>
            <div className={styles.sunset_radioline}></div>
            <div className={styles.sunset_arrow}></div>
            {isStingray ? (
              <div className={styles.sunset_stingray}></div>
            ) : (
              <div className={styles.sunset_tunein}></div>
            )}
            <div className={styles.sunset_close} onClick={() => close()}></div>
          </div>
          <div className={styles.sunset_content}>
            <h1>
              {isStingray
                ? t("sunset_title")
                : isPremium
                ? t("sunset_subject_premium")
                : t("sunset_subject")}
            </h1>

            {isStingray ? (
              <>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("sunset_desc", {
                      var1: "<p>&nbsp;</p>",
                      var2: "<p>&nbsp;</p>",
                      var3: "<p>&nbsp;</p>",
                    }),
                  }}
                />
                <p>&nbsp;</p>
              </>
            ) : isPremium ? (
              <>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("sunset_body_premium", {
                      var1: "<p>&nbsp;</p>",
                      var2: "<p>&nbsp;</p>",
                      var3: "<p>&nbsp;</p>",
                    }),
                  }}
                />
                <p>&nbsp;</p>
              </>
            ) : (
              <>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("sunset_body", { var1: "<p>&nbsp;</p>" }),
                  }}
                />
                <p>&nbsp;</p>
              </>
            )}
            <Link href={"https://listen.tunein.com/radioline"}>
              <Button className={styles.sunset_button}>{buttonText}</Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  ) : null;
};
